import { Segment } from '@fxtr/i18n';

export const FIXTER_TRANSLATION_SEGMENTS = [Segment.Fixter_UK, Segment.Fixter_FR];

// Some Segment members may be absent depending on the resolved @fxtr/i18n
// version, so drop any undefined values (mirrors the guard used in GarageForm).
export const MOTRIO_TRANSLATION_SEGMENTS = [
  Segment.Motrio_UK,
  Segment.Motrio_FR,
  Segment.Motrio_IT,
  Segment.Motrio_ES,
  Segment.Motrio_PT,
  Segment.Motrio_NL,
  Segment.Motrio_RO,
  Segment.Motrio_PL,
].filter(Boolean);

export function getTranslationSegmentsForApp(isMotrio) {
  return isMotrio ? MOTRIO_TRANSLATION_SEGMENTS : FIXTER_TRANSLATION_SEGMENTS;
}

export function getDefaultTranslationSegment(isMotrio) {
  return isMotrio ? Segment.Motrio_UK : Segment.Fixter_UK;
}

/** Human-readable labels for the top bar selector (segment = locale bundle). */
// Built from entries so undefined segments (absent from the resolved
// @fxtr/i18n version) don't create a stray "undefined" key.
export const TRANSLATION_SEGMENT_LABELS = Object.fromEntries(
  [
    [Segment.Fixter_UK, 'English (UK)'],
    [Segment.Fixter_FR, 'Français'],
    [Segment.Motrio_UK, 'English (UK)'],
    [Segment.Motrio_FR, 'Français'],
    [Segment.Motrio_IT, 'Italiano'],
    [Segment.Motrio_ES, 'Español'],
    [Segment.Motrio_PT, 'Português'],
    [Segment.Motrio_NL, 'Nederlands'],
    [Segment.Motrio_RO, 'Română'],
    [Segment.Motrio_PL, 'Polski'],
  ].filter(([segment]) => segment != null)
);
